import React, {lazy, useEffect, useState} from "react";
import ConditionalWrapper from "../../utils/ConditionalWrapper";

const AutosizeInput = lazy(() => import("../../utils/AutosizeInput"));

const Input = React.forwardRef((props, ref) => {

    const {...inputProps} = props;

    // TODO: Refactor
    if (inputProps.setJobagentObject) {
        delete inputProps.setJobagentObject;
    }
    // TODO: Refactor
    if (inputProps.type === "input") {
        delete inputProps.type;
    }

    const [autocomplete, setAutocomplete] = useState(null);
    const [input, setInput] = useState(null);

    useEffect(() => {
        if (input !== null) {
            const componentRestrictions = myTalentionConfig.geosearch?.componentRestrictions || {country: ["de"]};
            const options = {
                types: ["(cities)"],
                componentRestrictions,
            };
            if (autocomplete === null) {
                setAutocomplete(new google.maps.places.Autocomplete(input, options));
            }
        }

    }, [input]);

    const injectGoogleAutoComplete = () => {
        if (typeof google !== "object") {
            console.error("NO_GOOGLE_FOUND \n You tried to use a function that requires Google maps, but it was not found. Check your implementation or the key. Will ignore the Google maps functions like places autocomplete");
            return;
        }
        setInput(document.querySelector(
            ".tms-has-places-autocomplete input:not(.pac-target-input)"
        ));

    };
    useEffect(() => {
        if (autocomplete !== null) {
            autocomplete.addListener("place_changed", () => {
                inputProps.onChange(input, inputProps);
                props.setJobagentObject((oldJobagent) => {
                    return {
                        ...oldJobagent,
                        search: {
                            ...oldJobagent.search,
                            filter: {
                                ...oldJobagent.search.filter,
                                geoLocation: {
                                    lat: autocomplete.getPlace()
                                        .geometry
                                        .location
                                        .lat(),
                                    lng: autocomplete.getPlace()
                                        .geometry
                                        .location
                                        .lng(),
                                    radius: window.myTalentionConfig.jobagentRadius || 80,
                                    label: autocomplete.getPlace().name,
                                }
                            }
                        }
                    };
                });
            });

            input.addEventListener("keypress", (e) => {
                if (e.which == 13) {
                    e.preventDefault();
                }
            });

        }

    }, [autocomplete]);
    useEffect(() => {
        if (inputProps.places) {
            const input = document.querySelector(".tms-has-places-autocomplete input");

            if (input && document.querySelector(".pac-container") === null) {
                injectGoogleAutoComplete(input);
            }

        }
    });
    return (

        <ConditionalWrapper
            condition={inputProps.showLabel}
            wrapper={(children) => (
                <label htmlFor={inputProps.name} aria-labelledby={inputProps.name} id={`tms-label--${inputProps.name}`}
                       className={["tms-input-label-wrapper", inputProps.required ? "tms-is-required" : null].join(" ")}>

                    {inputProps.label &&
                        (<div className={"tms-label"}>
                            <span>{inputProps.label}</span>
                            {inputProps.required ? null :
                                <span
                                    className={"tms-is-optional"}>{props.translations.optional}</span>}
                        </div>)
                    }

                    <div className={"tms-input-wrapper"}>{children}</div>
                </label>
            )}
        >
            <>
                {inputProps.placeholder && !inputProps.value ? <span
                    className={"tms-place-enter-value"}>{props.translations.pleaseEnter}</span> : null}
                <AutosizeInput
                    {...inputProps}
                    type={inputProps.type ? inputProps.type : "text"}
                    ref={ref}/>
            </>
        </ConditionalWrapper>

    );
});

export default Input;
